import { render, staticRenderFns } from "./MasterFormulaSection.vue?vue&type=template&id=5f1a38b6&scoped=true"
import script from "./MasterFormulaSection.vue?vue&type=script&lang=js"
export * from "./MasterFormulaSection.vue?vue&type=script&lang=js"
import style0 from "./MasterFormulaSection.vue?vue&type=style&index=0&id=5f1a38b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1a38b6",
  null
  
)

export default component.exports